/**
 * Stripe Elements Appearance API — Payment Element tabs styled to align with Chekkit
 * checkout buttons (black primary, outlined secondary). Only Appearance `variables`
 * and documented `rules` apply inside Stripe iframes; host CSS cannot target them.
 *
 * @see https://docs.stripe.com/elements/appearance-api
 */
export function getStripeInvoiceAppearance() {
	return {
		theme: 'flat',
		labels: 'floating',
		// `condensed` clips the bottom border of the last row of fields.
		inputs: 'spaced',
		// Input colors, font, border, and padding match the pre-upgrade CardElement
		// so the checkout keeps its compact look.
		variables: {
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmooth: 'always',
			fontSizeBase: '16px',
			fontSizeSm: '13px',
			borderRadius: '8px',
			buttonBorderRadius: '6px',
			colorPrimary: '#000000',
			colorBackground: '#ffffff',
			colorText: '#32325d',
			colorTextSecondary: '#6b7280',
			colorTextPlaceholder: '#aab7c4',
			colorDanger: '#fa755a',
			buttonColorBackground: '#000000',
			buttonColorText: '#ffffff',
			tabSpacing: '8px',
			spacingUnit: '4px',
			accordionItemSpacing: '8px',
			gridRowSpacing: '12px',
			gridColumnSpacing: '12px',
			focusBoxShadow: '0 0 0 2px rgba(0, 0, 0, 0.15)',
			// Default + hover: keep icons/logos dark (Stripe’s hover defaults can be very low contrast).
			tabIconColor: '#111827',
			tabIconHoverColor: '#111827',
			// Logos: Stripe only allows "light" | "dark", not hex.
			tabLogoColor: 'dark',
			tabLogoSelectedColor: 'light',
			tabIconSelectedColor: '#ffffff',
		},
		rules: {
			'.Input': {
				border: '1px solid #e2e8f0',
				boxShadow: 'none',
				padding: '12px',
			},
			'.Input:focus': {
				borderColor: '#cbd5e1',
				boxShadow: 'none',
			},
			'.Label': {
				color: '#aab7c4',
			},
			// Let Stripe’s layout use `colorBackground` — avoid an extra framed “inner card”.
			'.Block': {
				border: 'none',
				boxShadow: 'none',
				backgroundColor: 'transparent',
			},
			'.Tab': {
				border: '1px solid #e5e7eb',
				borderRadius: '4px',
				padding: '10px 14px',
				boxShadow: 'none',
				color: '#111827',
			},
			'.Tab:hover': {
				backgroundColor: '#f3f4f6',
				borderColor: '#d1d5db',
				color: '#111827',
				'-webkit-text-fill-color': '#111827',
			},
			'.Tab--selected': {
				backgroundColor: '#000000',
				borderColor: '#000000',
				color: '#ffffff',
				'-webkit-text-fill-color': '#ffffff',
			},
			'.Tab--selected:hover': {
				backgroundColor: '#1a1a1a',
				borderColor: '#1a1a1a',
				color: '#ffffff',
				'-webkit-text-fill-color': '#ffffff',
			},
			// Tab row container is not a public Appearance selector (only .Tab / .TabIcon / .TabLabel).
			// Use `tabSpacing` in variables for horizontal gap between tabs.
		},
	};
}
